import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './plugins/element.js'
import { Popover, MessageBox } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import AOS from "aos"
import "aos/dist/aos.css"
import VueTypedJs from 'vue-typed-js'

Vue.use(VueTypedJs)

Vue.use(Popover)
Vue.prototype.$alert = MessageBox.alert
Vue.config.productionTip = false

new Vue({
  created() {
    AOS.init();
  },
  render: h => h(App),
  router,
  store
}).$mount('#app')
